import ContentView from "Components/ContentView/ContentView";
import * as React from "react";

interface IProps {}

interface IState { hasError: boolean; }

export class ErrorBoundary extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  public componentDidCatch() {
    this.setState({ hasError: true });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ContentView id="cnvTaskTemplateBlockOverview">
          <h1>We're sorry, something went wrong :-(</h1>
          <br/>
          <p>We tried processing your request, but something broke down.</p>
          <p>Please try <a href="">reloading</a> the page or to navigate via the menu at the top of this page.</p>
          <p>If the problem presists, please contact EZ Factory.</p>
        </ContentView>
      );
    }

    return this.props.children; 
  }
}


// WEBPACK FOOTER //
// ./src/Components/ErrorBoundary/ErrorBoundary.tsx